export const environment = {
  production: true,
  apiUrl: "https://api.jidvei.ro",
  clubUrl: "https://club.jidvei.ro",
  staffUrl: "https://staff.jidvei.ro",
  sentryDsnStaff: "https://9ce9a70671ad739dfdb41d5ed741f8a9@o4511765998534656.ingest.de.sentry.io/4511766040936528",
  sentryEnvironment: "production",
};
